module.exports = __webpack_public_path__ + "chat-icon.e0d2b748.svg";